import http from '../common/http';
import env from '../envConfig';
import { getHeader } from '../auth/authManager';
import { responseHandler } from '../common/responseHandler';

export const obterIntegrantesFamilia = async (numeroFamiliar: number) => {
  const url = env.urlApi + `/transacional-api/v1/renda/familia/${numeroFamiliar}`;
  const headers = getHeader();
  const response = await http.get(url, { headers });
  return responseHandler(response);
};

export const obterDadosRendaCNIS = async (idPessoa: number,
  nuFamiliar: number,
  cpf : number) => {
 const url = env.urlApi + `/transacional-api/v1/renda/pessoa/${idPessoa}?nuFamiliar=${nuFamiliar}&nuCpf=${cpf}`;
 const headers = getHeader();
 const response = await http.get(url, { headers });
 return responseHandler(response);
};

export const obterDadosRendaAtualizada = async (idPessoa: number,
  nuFamiliar: number,
  cpf : number) => {
 const url = env.urlApi + `/transacional-api/v1/renda/pessoa/${idPessoa}/povoada?nuFamiliar=${nuFamiliar}&nuCpf=${cpf}`;
 const headers = getHeader();
 const response = await http.get(url, { headers });
 return responseHandler(response);
};

export const obterTrabalhoERendaPessoa = async (idPessoa: number) => {
  const url = env.urlApi + `/transacional-api/v1/renda/pessoa/trabalho-renda/${idPessoa}`;
  const headers = getHeader();
  const response = await http.get(url, { headers });
  return responseHandler(response);
};
